<template>
  <div>
     <el-dialog :title="rowData.status === 'view'? '查看分组标签':rowData.status === 'edit'? '编辑分组标签':'新增分组标签'" :visible.sync="addDialogVisible" class="imgbox" width="35%" :before-close="resetForm" :append-to-body="true" :close-on-click-modal="false">
     <el-form  ref="ruleForm" :model="form" :rules="rules" :disabled="rowData.status==='view'" label-position="right">
       <el-form-item
        label-width="120px"
        prop="category">
          <el-row slot="label">
            <span class="name">品类</span>
            <el-tooltip content="所选品类为已注册产品品类" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
            <el-select
              @change="categorySel"
              :disabled="rowData.status ==='view' || rowData.status === 'edit'?true:false"
              v-model="form.category"
              placeholder="请选择产品品类"
              style="width: 100%;">
              <el-option
                v-for="item in category"
                :key="item.id"
                :label="item.commonName"
                :value="item.id"/>
            </el-select>
        </el-form-item>
        <el-form-item
        v-if="form.category"
        prop="brand"
        label-width="120px"
        >
            <el-row slot="label">
              <span class="name">品牌</span>
              <el-tooltip content="根据所选品类选择对应品牌" placement="top" effect="light">
                <span class="el-icon-question" style="margin-left: 10px"></span>
              </el-tooltip>
            </el-row>
            <el-select
              @change="brandSel"
              v-model="form.brand"
              placeholder="请选择品牌"
              style="width: 100%;">
              <el-option
                v-for="item in brand"
                :key="item.id"
                :label="item.commonName"
                :value="item.id"/>
            </el-select>
        </el-form-item>
        <el-form-item
          v-if="modelFlag"
          label="型号"
          prop="model"
          label-width="120px"
          >
            <el-row slot="label">
              <span class="name">型号</span>
              <el-tooltip content="根据所选品类与品牌选择对应型号" placement="top" effect="light">
                <span class="el-icon-question" style="margin-left: 10px"></span>
              </el-tooltip>
            </el-row>
            <el-select
              v-model="form.model"
              placeholder="请选择产品型号"
              style="width: 100%;">
              <el-option
                v-for="item in productType"
                :key="item.id"
                :label="item.commonName"
                :value="item.id"/>
            </el-select>
        </el-form-item>
        <el-form-item  label-width="120px" prop="signDesc">
          <el-row slot="label">
            <span class="name">分组标签名</span>
            <el-tooltip content="分组标签仅支持中文、英文、数字、下划线！" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-input
            v-model="form.signDesc"
            placeholder="例如：节能电灯"
            :maxlength="255"
            >
          </el-input>
        </el-form-item>
     </el-form>
      <div slot="footer" class="dialog-footer" v-if="rowData.status==='view'">
        <el-button @click="resetForm">关闭</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addGroup, groupDetail, editGroup } from '@/api/groupLabel'
import { brandList, subCategoryList, modelList } from '@/api/appGuide'
export default {
  props: {
    addDialogVisible: {
      type: Boolean
    },
    rowData: {
      type: Object
    }
  },
  data () {
    const validate = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5_]{0,}$/
      if (value) {
        console.log(reg)
        reg.test(value) ? callback() : callback(new Error('仅支持输入中文、英文字母、数字和下划线'))
      } else {
        callback(new Error('请输入标签名称'))
      }
    }
    return {
      form: {
        category: '',
        brand: '',
        model: '',
        signDesc: ''
      },
      rules: {
        category: [
          { required: true, message: '请选择产品品类', trigger: 'blur' }
        ],
        brand: [
          { required: true, message: '请选择产品品牌', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请选择产品型号', trigger: 'blur' }
        ],
        signDesc: [
          { required: true, trigger: 'blur' },
          { validator: validate, trigger: 'blur' },
          { max: 20, message: '请输入20个字符以内的分组标签名！', trigger: 'blur' }
        ]
      },
      category: [], // 品类
      brand: [], // 品牌
      productType: [] // 型号
    }
  },
  watch: {
    'form.category': {
      immediate: true,
      handler (val) {
        if (val) {
          this.getBrandList()
        }
      }
    }
  },
  computed: {
    modelFlag () {
      if (this.form.category && this.form.brand) {
        this.getModelId()
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getCategoryList()
    if (this.rowData && this.rowData.signId) {
      console.log(11)
      const params = this.rowData.signId
      groupDetail({ params }).then(res => {
        if (res.data.code === 200) this.form = Object.assign(res.data.data)
      })
    }
  },
  methods: {
    categorySel (val) {
      this.form.model = ''
      this.form.brand = ''
    },
    brandSel (val) {
      this.form.model = ''
    },
    // 获取品牌信息
    getBrandList () {
      const params = this.form.category
      brandList({ params }).then((res) => {
        const result = res.data.data
        this.brand = result
      })
    },
    // 获取品类信息
    getCategoryList () {
      const params = {
        flag: '1'
      }
      subCategoryList({ params }).then((res) => {
        const result = res.data.data
        this.category = result
      })
    },
    // 获取型号
    getModelId () {
      // this.form.model = ''
      const params = {
        categoryId: this.form.category,
        productBrand: this.form.brand
      }
      modelList({ params }).then((res) => {
        const result = res.data.data
        this.productType = result
      })
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const categoryName = this.category.find((item, index) => {
            return item.id === this.form.category
          })
          const brandName = this.brand.find((item, index) => {
            return item.id === this.form.brand
          })
          const params = Object.assign({}, this.form)
          params.categoryName = categoryName.commonName
          params.brandName = brandName.commonName
          if (this.rowData.status === 'edit') {
            // 调用编辑接口
            editGroup({ params }).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          } else {
            addGroup({ params }).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '表单验证不通过，请重试'
          })
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>
  /deep/ .el-form-item__label{
      display:flex;
      align-items: center !important;
    }
</style>
